import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  providers: [
    //SecurityService, SecurityBLService, SecurityDLService, AuthGuardService
  ],
  imports: [
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    HttpClientModule
  ],
  declarations: [],
  bootstrap: []
})
export class SecurityModule { }
